// extracted by mini-css-extract-plugin
export default {"container":"qH-z","innerContainer":"rH-z","multipleLines":"sH-z","heading":"tH-z","content":"uH-z","linkColor":"vH-z"};